<script>
	import { onMount, getContext, onDestroy } from 'svelte'
	import { adminUpdateRoomsEntry, SingleItem, ghRoomNumber } from '../AdminModule.svelte'
	import { slide } from 'svelte/transition'
	import { url, urlAdmin } from '../../../library/scripts/Setup.svelte'
	import { storeShowItem, storeUploader, storeRemainingStorage } from '../../../library/scripts/Store.svelte'
	import { get_username, get_file_size } from '../../../library/scripts/utils'
	import { getCookie } from '../../../library/scripts/cookie'
	import { styles } from '../../../library/scripts/styles'
	import Shader from '../../../library/ShadersAndSpinners/Shader.svelte'
	import Alert from '../../../modals/Alert.svelte'

	const globals = getContext('globals')
	const fsX = globals.fsL
	const fsN = globals.fsN
	const fsS = globals.fsS
	const fsXS = globals.fsXS
	const color = globals.colorMain
	const colorError = globals.colorError
	const shadow = globals.boxShadow
	const buttonColor = globals.buttonColor
	const buttonHover = globals.buttonHover

	const userID = getCookie('id')

	let rooms = []

	//the room number from store
	let roomNumber
	const stoRoomNumber = ghRoomNumber.subscribe((value) => {
		roomNumber = parseInt(value)
	})

	//show single item
	let showItem
	const stoShowItem = storeShowItem.subscribe((value) => {
		showItem = value
	})

	let bookings = []

	let alertError = false
	let message = ''
	let roomId = null

	const show_item = (id) => {
		storeShowItem.set(true)

		rooms.forEach((room) => {
			if (room.number === id) {
				roomId = id
				bookings = room.bookings.split(',')
				if (typeof room.image === 'object') {
					const sessRooms = JSON.parse(sessionStorage.getItem('roomsimg'))
					sessRooms.forEach((value) => {
						for (const entry in value) {
							if (value['room'] === id) room.image = value['image']
						}
					})
				}
			}
		})
	}

	const close_item = () => {
		storeShowItem.set(false)
		showItem = false
	}

	const reset_error = () => {
		alertError = false
		message = ''
	}

	const delete_item = async (number) => {
		// delete item from DB
		const deleteItem = await fetch(urlAdmin, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				cmd: 'delete_room',
				data: {
					number: number,
				},
			}),
		})
		const response = await deleteItem.json()

		if (response) {
			storeUploader.set(false)
			showItem = false
			let newRooms = []

			response.fetch.forEach((item) => {
				let tmpItem = {
					number: item[0],
					bedSize: item[1],
					guests: item[2],
					description: item[3],
					image: item[4],
					low: item[5],
					high: item[6],
					bookings: item[7],
					currency: item[8],
					breakfast: item[9],
				}

				//add the item at the beginning of the array menu
				newRooms.push(tmpItem)
			})

			//update store & session
			sessionStorage.setItem('rooms', JSON.stringify(newRooms))
			adminUpdateRoomsEntry.set(JSON.stringify(newRooms))

			//update room number
			ghRoomNumber.set(newRooms.length + 1)

			//get the file-size
			const fileSize = get_file_size()
			fileSize.then((value) => {
				storeRemainingStorage.set(value)
			})
		}
	}

	const alterate_item = (item) => {
		let oldRooms = sessionStorage.getItem('rooms')
		oldRooms = JSON.parse(oldRooms)
		oldRooms.forEach((om) => {
			if (om.number === item.number) {
				SingleItem.set(
					item.number +
						'~' +
						item.bedSize +
						'~' +
						item.guests +
						'~' +
						item.description +
						'~' +
						item.image +
						'~' +
						item.low +
						'~' +
						item.high +
						'~' +
						item.booking +
						'~' +
						item.currency +
						'~' +
						item.breakfast
				)
			}
		})
	}

	onMount(async () => {
		adminUpdateRoomsEntry.subscribe((value) => {
			rooms = JSON.parse(value)
		})
	})

	onDestroy(() => {
		stoShowItem
		stoRoomNumber
	})
</script>

<div class="container">
	{#if !showItem}
		<div style="width:100%" transition:slide={{ duration: 500, delay: 600 }}>
			<div class="title" use:styles={{ fsX, color }}>ROOMS PREVIEW</div>
			<!-- no entry yet -->

			{#if rooms === null || rooms.length === 0}
				<div class="message error" use:styles={{ fsN, colorError }}>No entry yet</div>
			{:else}
				<div class="item_grid" use:styles={{ fsN, color }}>
					<div style="text-decoration: underline;">room name</div>
					<div />
					<div style="text-decoration: underline;" class="align_center">low season</div>
					<div style="text-decoration: underline;" class="align_center">high season</div>
				</div>
				<div class="spacer" />

				{#each rooms as item}
					<div class="item_grid" use:styles={{ fsN, color }}>
						<div>Room {item.number}</div>
						<div class="align_center">{item.currency}</div>
						<div class="align_center">{item.low}</div>
						<div class="align_center">{item.high}</div>
						<div class="show_item" on:click={() => show_item(item.number)} on:keydown={() => show_item(item.number)} />
						<div class="link" on:click={() => delete_item(item.number)} on:keydown={() => delete_item(item.number)} />
					</div>
				{/each}
				<div class="spacer" />
			{/if}
		</div>
	{/if}

	{#if showItem}
		<div id="singleItem" style="width:100%;" transition:slide={{ duration: 500, delay: 600 }}>
			{#each rooms as item}
				{#if roomId === item.number}
					<div class="single_item_menu_bar">
						<div class="title" use:styles={{ fsX, color }}>Room {item.number}</div>
					</div>
					<div class="sub_title" use:styles={{ fsN, color }}>beds</div>
					<div class="description" use:styles={{ fsN, color }}>{item.bedSize}</div>
					<div class="sub_title" use:styles={{ fsN, color }}>sleeps</div>
					<div class="description" use:styles={{ fsN, color }}>{item.guests}</div>
					<div class="sub_title" use:styles={{ fsN, color }}>description</div>
					<div class="description" use:styles={{ fsN, color }}>{item.description}</div>
					<div class="sub_title" use:styles={{ fsN, color }}>image</div>
					<div class="description" use:styles={{ fsN, color }}>{item.image}</div>
					<div class="room_image">
						<img id="alt_image" src="{url}/rooms/thumbnail/{item.image}" alt="room" />
					</div>
					<div class="sub_title" />
					<div class="sub_title" use:styles={{ fsN, color }}>pricing</div>
					<div class="item_row" use:styles={{ fsN, color }}>
						<div>low season</div>
						<div>{item.currency}</div>
						<div>{item.low}</div>
						<div>high season</div>
						<div>{item.currency}</div>
						<div>{item.high}</div>
					</div>
					<div class="button_container">
						<button use:styles={{ fsS, shadow, buttonColor, buttonHover }} on:click={() => alterate_item(item)}
							>amend</button
						>
						<button use:styles={{ fsS, shadow, buttonColor, buttonHover }} on:click={() => delete_item(item.number)}
							>delete</button
						>

						<button use:styles={{ fsS, shadow, buttonColor, buttonHover }} on:click={close_item}>close</button>
					</div>
				{/if}
			{/each}
		</div>
	{/if}
</div>

{#if alertError}
	<Shader>
		<div slot="content">
			<Alert {message} showOkButton={false} alertMessage="ERROR" on:alertclose={reset_error} />
		</div>
	</Shader>
{/if}

<style>
	button {
		width: 20%;
		grid-column-start: 1;
		grid-column-end: 3;
		justify-self: flex-end;
		margin-right: 0%;
		border-radius: 5px;
		font-size: var(--fsS);
		color: var(--buttonColor);
		box-shadow: 3px 3px 3px var(--shadow);
		background-color: transparent;
		cursor: pointer;
	}

	button:hover {
		background-color: var(--buttonHover);
	}

	.button_container {
		margin-top: 30px;
	}
	.container {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
		margin-left: 5%;
		width: 100%;
		cursor: default;
		user-select: none;
	}
	.title {
		font-size: var(--fsX);
		font-weight: bold;
		color: var(--color);
		margin: 30px 0 20px 0;
	}

	.item_grid {
		display: grid;
		width: 80%;
		grid-template-columns: 45% 5% 20% 20% 5% 5%;
		font-size: var(--fsN);
		grid-gap: 2%;
		color: var(--color);
		cursor: default;
		user-select: none;
	}

	.single_item_menu_bar {
		display: flex;
		width: 85%;
		align-items: center;
		justify-content: space-between;
	}

	.sub_title,
	.description {
		display: block;
		width: 95%;
		color: var(--color);
		font-size: var(--fsN);
		margin-bottom: 20px;
	}

	.sub_title {
		text-decoration: underline;
	}

	.item_row {
		width: 95%;
		display: grid;
		grid-template-columns: 25% 5% 70%;
		color: var(--color);
		font-size: var(--fsN);
		grid-row-gap: 15px;
	}

	.link,
	.show_item {
		cursor: pointer;
		width: 25px;
		height: 25px;
		background-repeat: no-repeat;
		background-size: cover;
	}
	.link {
		background-image: url('/images/bin.png');
	}
	.show_item {
		background-image: url('/images/icon_eye.png');
	}

	.align_center {
		justify-self: center;
	}

	.spacer {
		min-height: 1.5vh;
	}

	.message {
		font-size: var(--fsN);
	}

	.error {
		color: var(--colorError);
	}
</style>
